import React from 'react';
import { supabase } from '../supabase';
import { useState } from 'react';
import { useEffect} from 'react';
import Cta from '../components/common/cta';
import SecCta from '../components/common/secondarycta';
import Cardnotification from '../components/common/card-notification';
import pic14 from '../assets/pic14.png'
import { useNavigate } from 'react-router-dom';
const Notificationsec = () => {


 const [content, setcontent]= useState([]);
      useEffect(() => {
      const getcontent = async()=>{
          const res = await supabase.from('static_content').select('*').order('id', { ascending: true });;;
    
      setcontent(res.data);
      }
      getcontent();
      }, []);





 const [notification, setnotification]= useState([]);
      useEffect(() => {
      const getnotification = async()=>{
          const res = await supabase.from('notification_mobile').select('*').order('id', { ascending: true });;;
    
      setnotification(res.data);
      }
      getnotification();
      }, []);



const timeAgo = (date) => {
  const now = new Date();
  const past = new Date(date);
  const diff = Math.floor((now - past) / 1000); 


      const minutes = Math.floor(diff / 60);

  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

if (diff < 60) return "just now";
  if (minutes < 60) return `${minutes} minute${minutes !== 1 ? "s" : ""} ago`;
  if (hours < 24) return `${hours} hour${hours !== 1 ? "s" : ""} ago`;


  
  return `${days} day${days !== 1 ? "s" : ""} ago`;
};


const navigate = useNavigate();






    return ( 
        <section className='notification-sec'>
            <section className='map-container-sec'>
                    <section className='container-header-notification'>
                        <img src={pic14} alt='back'   onClick={() => navigate(-1)} ></img>
                         <h1 className='header-map-section '>{content?.[28]?.header}</h1>
                    </section>

                    <section className='container-notification-box'>
                        <nav className='container-cta-map'>
                            <button className='button-containerr-map'>
                                <Cta title={content?.[28]?.cta2} />
                               
                            </button>
                              <button className='button-containerr-map'>
                             <SecCta title={content?.[28]?.cta2}  />
                             </button>
                        </nav>


                        <article className='row-notification' >
                              

                            {notification?.map((item) => (
                                <Cardnotification
                                img={item.img}
                                title={item.header}
                                alt={item.img_alt}
                                para={item.para}
                                    time={timeAgo(item.updated_at)}
                                />
                            ))}

                        </article>
                        
                    </section>
            </section>
        </section>
     );
}
 
export default Notificationsec;